// A-Risk — Pure formula. Zero AI. Instant.
// XAU/USD: 1 lot = $100 profit/loss per $1 price move

import { JARVIS_DNA } from '../../dna/jarvisDNA';

export async function run({ account_size, risk_pct, entry, sl, tp = null }) {
  // Read from JARVIS_DNA here, not at module top-level — see A_Fibonacci.js
  // for why (crashed the whole app in production build otherwise).
  const DNA = JARVIS_DNA.trading;
  // Use DNA defaults if not provided
  const acct     = +account_size || DNA.risk_rules.default_account_size;
  const riskPct  = +(risk_pct ?? DNA.risk_rules.max_risk_per_trade_pct);
  const pipVal   = DNA.pip_value; // $100 per lot per $1 move (gold)

  if (!entry || !sl) return { ok: false, error: 'entry and sl required' };
  if (entry <= 0 || sl <= 0) return { ok: false, error: 'entry and sl must be positive' };

  const slDist   = +Math.abs(entry - sl).toFixed(2);
  if (slDist === 0) return { ok: false, error: 'Entry and SL cannot be the same price' };

  const riskUSD  = +(acct * riskPct / 100).toFixed(2);
  const lotSize  = +(riskUSD / (slDist * pipVal)).toFixed(2);
  const actualRisk = +(lotSize * slDist * pipVal).toFixed(2);

  // Take profit calculations
  const tpDist   = tp ? +Math.abs(tp - entry).toFixed(2) : 0;
  const rrRatio  = tpDist > 0 ? +(tpDist / slDist).toFixed(2) : 0;
  const potentialProfit = tpDist > 0 ? +(lotSize * tpDist * pipVal).toFixed(2) : 0;

  // Warnings (rule-based, no AI)
  const warnings = [];
  if (lotSize  > DNA.risk_rules.max_lot_size)         warnings.push(`Lot ${lotSize} exceeds max ${DNA.risk_rules.max_lot_size}`);
  if (riskPct  > DNA.risk_rules.max_risk_per_trade_pct) warnings.push(`Risk ${riskPct}% exceeds DNA max ${DNA.risk_rules.max_risk_per_trade_pct}%`);
  if (rrRatio  > 0 && rrRatio < DNA.risk_rules.min_rr)  warnings.push(`R:R ${rrRatio} below minimum ${DNA.risk_rules.min_rr}`);

  // Check today's P&L from journal (daily loss limit)
  let todayPnL = 0;
  try {
    const trades = JSON.parse(localStorage.getItem('jarvis_trades') || '[]');
    const today  = new Date().toDateString();
    todayPnL = trades
      .filter(t => new Date(t.date).toDateString() === today)
      .reduce((s, t) => s + (+t.pnl_usd || 0), 0);
  } catch {}

  const dailyLossLimit = -(acct * DNA.risk_rules.max_daily_loss_pct / 100);
  if (todayPnL < dailyLossLimit) {
    warnings.push(`Daily loss limit hit: $${todayPnL.toFixed(0)} (max: $${dailyLossLimit.toFixed(0)}). STOP trading.`);
  }

  const safe = warnings.length === 0 || (
    !warnings.some(w => w.includes('STOP') || w.includes('exceeds'))
  );

  return {
    ok:    true,
    acct,
    riskPct,
    riskUSD,
    entry: +entry, sl: +sl, tp: tp ? +tp : null,
    slDist, tpDist,
    lotSize,
    actualRisk,
    rrRatio,
    potentialProfit,
    todayPnL: +todayPnL.toFixed(2),
    warnings,
    safe,
    verdict: safe ? 'SAFE TO TRADE' : 'REVIEW WARNINGS',
    recommendation: safe
      ? `Trade ${lotSize} lots. Risk $${actualRisk}. ${rrRatio > 0 ? `Potential: $${potentialProfit} (${rrRatio}:1 R:R)` : ''}`
      : `Adjust trade — ${warnings[0]}`,
    agent: 'A-Risk',
    requiresAI: false,
    ts: Date.now(),
  };
}
